import {createAutoStartSetting} from './createAutoStartSetting';

const {ButtonComponent: AutoStartButton} = createAutoStartSetting();

export default AutoStartButton;
